import { Loader as KLoader } from '@progress/kendo-react-indicators';

import classes from './Loader.module.scss';

const Loader = (): JSX.Element => (
  <div className={classes.loader}>
    <div className="plane" data-testid="loader-container">
      <KLoader type="infinite-spinner" size="large" />
    </div>
  </div>
);

export default Loader;
